// GraphQL document sent to general v2. Returns the one-time SSO token for the Coaching app.
export const GET_COACHING_TOKEN_MUTATION = `
  mutation getCoachingToken {
    getCoachingToken
  }
`;
